import apisauce from 'apisauce';
import ApiMonitor from './apiMonitor';
import AppConfig from '../../config/appConfig';

const getUserInformation = () => {
    // define the api
    const configurationApi = apisauce.create({
        baseURL: AppConfig.apiUrl,
        headers: {
            'cache-control': 'no-cache',
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        timeout: 10000,
        mode: 'no-cors',
    });

    ApiMonitor(configurationApi);

    const userData = configurationApi.get('user');
    return userData;
};

export default { getUserInformation };
